export default "__VITE_ASSET__BA0wEOYZ__"